'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class SalaryComponentSplitShiftRulesList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'lower_limit_hours',
				type: 'string',
				canAdd: true,
				canEdit: true,
			},
		];
		this.settings = {
			name: 'SalaryComponentSplitShiftRulesList',
			allowEmpty: true,
			alwaysRefresh: true,
			canAdd: true,
			canEdit: true,
			canDelete: true,
			canManipulate: () => validAccess(undefined, ['Salary Admin']),
			translationPath: 'SALARY.SALARY_COMPONENT_SPLIT_SHIFT_RULES',
			endpoint: __endpoints.collection.salary.salary_component_split_shift_rules,
		};
		this.init();
		return this;
	}
}
